import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { assert } from '@ember/debug'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type Store from '@ember-data/store'
import type Student from 'teacher-ui-client/models/student'
import { hasId } from 'teacher-ui-client/utils/type-guards'

export default class RexDashboardStudentRoute extends Route {
  @service store!: Store

  model({ student_id: studentId }: { student_id: string }) {
    const {
      scopedData: { students: scopedStudents },
    } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const student = this.store.peekRecord<Student>('student', studentId)
    assert('could not find student in ember-data store', student && hasId(student))

    return { scopedStudents, student }
  }
}
